"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("@app/helpers");
const useWindowWidrh_1 = __importDefault(require("@hooks/useWindowWidrh"));
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const useCardRecognizerExercise_1 = require("@app/routes/SpeechDevelopment/hooks/useCardRecognizerExercise");
const components_1 = require("@app/routes/SpeechDevelopment/components");
const exercise_1 = require("@components/container/exercise");
const BoxComponentWithImg_1 = __importDefault(require("@app/routes/SpeechDevelopment/components/BoxComponentWithImg"));
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const Pagination_1 = require("@components/Pagination");
const menuBarExercise_1 = __importDefault(require("@components/menuBar/menuBarExercise"));
const Button_1 = __importStar(require("@app/routes/SpeechDevelopment/components/Button"));
const translations_1 = require("@app/routes/SpeechDevelopment/translations");
const react_1 = __importDefault(require("react"));
const RecognizerCardExercise = ({ exerciseParams, isDisinhibition, }) => {
    var _a;
    const langId = (0, helpers_1.getCurrentLanguage)();
    const windowWidth = (0, useWindowWidrh_1.default)();
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    const { isStarted, isRecognizing, isLoading, isPaused, canLeaf, handleNext, handlePrev, handleStart, handlePause, handleEndExercise, answersFrameArray, currentCardIndex, card, } = (0, useCardRecognizerExercise_1.useCardRecognizerExercise)({ exerciseParams, addCoin });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isLoading && react_1.default.createElement(components_1.Loader, null),
        react_1.default.createElement(exercise_1.ContainerExercise, null,
            react_1.default.createElement(exercise_1.ExerciseWrapper, { wihMargin: windowWidth <= 1200 },
                react_1.default.createElement(components_1.DropContainerWrapper, null,
                    react_1.default.createElement(BoxComponentWithImg_1.default, { isDisinhibition: isDisinhibition, list: [card], customAnswer: card === null || card === void 0 ? void 0 : card.userRightAnswer, correctSayedWord: card === null || card === void 0 ? void 0 : card.userRightAnswer }),
                    react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                react_1.default.createElement(Pagination_1.Pagination, null, answersFrameArray.map((item) => (react_1.default.createElement(Pagination_1.PaginationItem, { key: item.id, item: item }))))),
            react_1.default.createElement(menuBarExercise_1.default, null,
                react_1.default.createElement(Button_1.ButtonContainerWrapper, null,
                    react_1.default.createElement(Button_1.default, { label: '←', disabled: currentCardIndex === 0 || !canLeaf, onClick: handlePrev }),
                    react_1.default.createElement(Button_1.default, { showBlick: true, label: (0, translations_1.getLabelPauseButton)(langId, isRecognizing, isStarted && !isRecognizing), isStarted: isStarted, onClick: isStarted ? handleEndExercise : handleStart, isCheckButton: false }),
                    react_1.default.createElement(Button_1.default, { label: isPaused ? '❚ ❚' : '▶', onClick: isRecognizing ? handlePause : handleStart, disabled: !isStarted || !canLeaf, color: isPaused ? '#F2A000' : null }),
                    react_1.default.createElement(Button_1.default, { label: '→', disabled: currentCardIndex === ((_a = exerciseParams === null || exerciseParams === void 0 ? void 0 : exerciseParams.text) === null || _a === void 0 ? void 0 : _a.offers.length) - 1 ||
                            !isStarted ||
                            !canLeaf, onClick: handleNext }))))));
};
exports.default = RecognizerCardExercise;
